export default "__VITE_ASSET__Bk44D$MG__"